import './styles/global.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { App as AntdApp, ConfigProvider, message, notification, theme } from 'antd';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import AppLayout from './components/AppLayout';
import AdminDashboard from './pages/dashboards/AdminDashboard';
import SupervisorDashboard from './pages/dashboards/SupervisorDashboard';
import StudentDashboard from './pages/dashboards/StudentDashboard';
import Residences from './pages/admin/Residences';
import Supervisors from './pages/admin/Supervisors';
import Semestres from './pages/admin/Semestres';
import AdminStudents from './pages/admin/Students';
import WeekendStats from './pages/admin/WeekendStats';
import AdminAccounts from './pages/admin/AdminAccounts';
import StudentImport from './pages/admin/StudentImport';
import SupStudents from './pages/supervisor/Students';
import SupSorties from './pages/supervisor/Sorties';
import SupIssues from './pages/supervisor/Issues';
import SupReports from './pages/supervisor/Reports';
import SupRooms from './pages/supervisor/Rooms';
import QRValidate from './pages/supervisor/QRValidate';
import SupEvaluations from './pages/supervisor/Evaluations';
import AdminProfile from './pages/admin/Profile';
import NewSortie from './pages/student/NewSortie';
import MySorties from './pages/student/MySorties';
import Issues from './pages/student/Issues';
import ScanSupervisorQR from './pages/student/ScanSupervisorQR';
import StudentReports from './pages/student/Reports';
import ForceChangePassword from './pages/ForceChangePassword';
import AiKnowledge from './pages/admin/AiKnowledge';

message.config({ top: 80, duration: 3, maxCount: 3 });
notification.config({ placement: 'topRight', top: 80, duration: 4, maxCount: 3 });

function App() {
  return (
    <ConfigProvider
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary: '#6b4f4f',
          colorBgBase: '#f7f3ee',
        },
      }}
    >
      <AntdApp>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />

              <Route element={<ProtectedRoute roles={["admin", "supervisor", "student"]} />}> 
                <Route path="/force-change-password" element={<ForceChangePassword />} />
              </Route>

              <Route element={<ProtectedRoute roles={["admin"]} />}> 
                <Route element={<AppLayout />}> 
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route path="/admin/residences" element={<Residences />} />
                  <Route path="/admin/supervisors" element={<Supervisors />} />
                  <Route path="/admin/semestres" element={<Semestres />} />
                  <Route path="/admin/students" element={<AdminStudents />} />
                  <Route path="/admin/weekend-stats" element={<WeekendStats />} />
                  <Route path="/admin/student-import" element={<StudentImport />} />
                  <Route path="/admin/admin-accounts" element={<AdminAccounts />} />
                  <Route path="/admin/ai-knowledge" element={<AiKnowledge />} />
                  <Route path="/admin/profile" element={<AdminProfile />} />
                </Route>
              </Route>

              <Route element={<ProtectedRoute roles={["supervisor"]} />}> 
                <Route element={<AppLayout />}> 
                  <Route path="/supervisor" element={<SupervisorDashboard />} />
                  <Route path="/supervisor/students" element={<SupStudents />} />
                  <Route path="/supervisor/rooms" element={<SupRooms />} />
                  <Route path="/supervisor/sorties" element={<SupSorties />} />
                  <Route path="/supervisor/issues" element={<SupIssues />} />
                  <Route path="/supervisor/reports" element={<SupReports />} />
                  <Route path="/supervisor/evaluations" element={<SupEvaluations />} />
                  <Route path="/supervisor/qr-validate" element={<QRValidate />} />
                </Route>
              </Route>

              <Route element={<ProtectedRoute roles={["student"]} />}> 
                <Route element={<AppLayout />}> 
                  <Route path="/student" element={<StudentDashboard />} />
                  <Route path="/student/new-sortie" element={<NewSortie />} />
                  <Route path="/student/sorties" element={<MySorties />} />
                  <Route path="/student/reports" element={<StudentReports />} />
                  <Route path="/student/scan-qr" element={<ScanSupervisorQR />} />
                  <Route path="/student/issues" element={<Issues />} />
                </Route>
              </Route>

              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </AntdApp>
    </ConfigProvider>
  );
}

export default App;
